module.exports = __webpack_public_path__ + "img/arrow-right.4f48995f.svg";